import { WebSocketReceiveMessage } from './web-socket-receive-message';

export class WebSocketBrandsDeleted extends WebSocketReceiveMessage {
  override payload: { id: string };
}
